import type { ActivityType } from '@/types/activity';
import { activityDetailPath } from '@/lib/paths';

interface RoutableActivity {
  id: string;
  slug?: string | null;
  activityType: ActivityType;
}

/**
 * Public detail page href — all types use /event/:id.
 */
export function getActivityDetailHref(a: RoutableActivity): string {
  return activityDetailPath(a.id);
}

/**
 * Producer portal edit href.
 */
export function getActivityEditHref(farmId: string, a: RoutableActivity): string {
  switch (a.activityType) {
    case 'excursion':
    case 'course':
    case 'event':
    default:
      return `/app/producer/farm/${farmId}/events/${a.id}/edit`;
  }
}

/**
 * Producer portal bookings href. Returns null for types without bookings (excursions).
 */
export function getActivityBookingsHref(farmId: string, a: RoutableActivity): string | null {
  switch (a.activityType) {
    case 'excursion':
      return null; // Outings don't have bookings
    case 'course':
    case 'event':
    default:
      return `/app/producer/farm/${farmId}/events/${a.id}/bookings`;
  }
}

/**
 * Public share href — same as detail for now.
 */
export function getActivityShareHref(a: RoutableActivity): string {
  return getActivityDetailHref(a);
}
